export interface ISidebarMenuItem {
  link: string | null
  key: string | null
  icon: string | null
}
